/** Đóng gói vertical ngách (#6). Real /api/v1/clinic/vertical. */
import { apiClient } from "./client";

export interface StarterService {
  code: string;
  name: string;
  category: string;
  priceVnd: number;
}

export interface Vertical {
  code: string;
  label: string;
  customerNoun: string;
  services: StarterService[];
}

export interface VerticalState {
  vertical: string;
  packApplied: boolean;
}

export interface VerticalConfig {
  state: VerticalState;
  catalog: Vertical[];
}

export interface ApplyResult {
  vertical: string;
  servicesCreated: number;
  servicesSkipped: number;
}

export const verticalApi = {
  get(): Promise<VerticalConfig> {
    return apiClient.get<VerticalConfig>("/v1/clinic/vertical").then((r) => r.data);
  },
  set(vertical: string): Promise<VerticalState> {
    return apiClient
      .put<VerticalState>("/v1/clinic/vertical", { vertical })
      .then((r) => r.data);
  },
  applyStarterPack(): Promise<ApplyResult> {
    return apiClient
      .post<ApplyResult>("/v1/clinic/vertical/apply-starter-pack")
      .then((r) => r.data);
  },
};

export const verticalQueryKeys = {
  config: () => ["clinic-vertical"] as const,
};
